import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "purpose-types";

export const getWellPurposeTypeList = () => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${apiURL}`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const addWellPurposeTypeItem = (data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${apiURL}/addWellPurposeType`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateWellPurposeTypeItem = (
	uuid: any,
	data: any,
	prevData: any
) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${apiURL}/updateWellPurposeType`,
				{
					filter: { uuid: uuid },
					data: data,
					options: { upsert: true, new: true },
					prevData: prevData,
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteWellPurposeTypeItem = (uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${apiURL}/deleteWellPurposeType`, {
				params: {
					filter: {
						uuid: uuid,
					},
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
